import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ShellTrackersService } from 'modules/shell/services/shell-trackers.service';

@Component({
	selector: 'faq-menu',
	templateUrl: './faq-menu.component.html',
	styleUrls: ['./faq-menu.component.scss'],
})
export class FaqMenuComponent {
	@ViewChild('faqmenu', { read: ElementRef }) faqMenuDOMElement: ElementRef;
	menuItems = [
		{
			label: 'Perguntas frequentes',
			icon: 'freud-icon freud-icon-info-circle',
			command: () => {
				this.shellTracker.trackHeaderMenuItemClick('faq');
				window.open(
					'https://hs-info.zenklub.com/faq/sou-especialista',
					'_blank',
					'noopener'
				);
			},
		},
		{
			label: 'Comunidade Zenxperts',
			icon: 'freud-icon freud-icon-users',
			command: () => {
				this.shellTracker.trackHeaderMenuItemClick('community');
				window.open('https://comunidade.zenklub.com.br/', '_blank', 'noopener');
			},
		},
		{
			label: 'Zenklub Academy',
			icon: 'freud-icon freud-icon-school',
			command: () => {
				this.shellTracker.trackHeaderMenuItemClick('academy');
				window.open(
					'https://comunidade.zenklub.com.br/courses/',
					'_blank',
					'noopener'
				);
			},
		},
		{
			label: 'Código de conduta',
			icon: 'freud-icon freud-icon-file-certificate',
			command: () => {
				this.shellTracker.trackHeaderMenuItemClick('conduct_code');
				window.open(
					'https://hs-info.zenklub.com/faq/c%C3%B3digo-de-conduta',
					'_blank',
					'noopener'
				);
			},
		},
	];
	isFaqMenuOpen = false;

	constructor(private shellTracker: ShellTrackersService) {}

	@HostListener('document:mousedown', ['$event'])
	onGlobalClick(event): void {
		if (event?.target?.classList.contains('freud-icon')) {
			event.preventDefault();
			return;
		}
		if (!this.faqMenuDOMElement?.nativeElement?.contains(event.target)) {
			this.isFaqMenuOpen = false;
		}
	}
}
